var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27956_202958)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4077 12C13.4077 14.0908 14.6106 15.0663 15.7739 16.008C17.2308 17.1896 18.8713 18.5195 19.0407 22.5882H4.95127C5.12068 18.5195 6.76114 17.1896 8.21808 16.008C9.38138 15.0663 10.5842 14.0908 10.5842 12C10.5842 9.90917 9.38138 8.93365 8.21808 7.992C6.76114 6.81035 5.12068 5.48048 4.95127 1.41176H19.0407C18.8713 5.48048 17.2308 6.81035 15.7739 7.992C14.6106 8.93365 13.4077 9.90917 13.4077 12ZM16.6633 9.08753C18.3574 7.71389 20.4666 6.00424 20.4666 0.705887V0H3.52539V0.705875C3.52539 6.00424 5.63457 7.71388 7.32869 9.08753C8.43833 9.98824 9.17244 10.5826 9.17244 12C9.17244 13.4174 8.43833 14.0118 7.32869 14.9125C5.63457 16.2861 3.52539 17.9958 3.52539 23.2941V24H20.4666V23.2941C20.4666 17.9958 18.3574 16.2861 16.6633 14.9125C15.5536 14.0118 14.8195 13.4174 14.8195 12C14.8195 10.5826 15.5536 9.98824 16.6633 9.08753ZM11.6734 15.9333L9.55292 17.6543C8.62398 18.4067 7.8235 19.0547 7.39433 20.4707H16.5976C16.1685 19.0547 15.368 18.4067 14.439 17.6543L12.3186 15.9333C12.1308 15.7809 11.8612 15.7809 11.6734 15.9333Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27956_202958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourGlass);
export default __webpack_public_path__ + "static/media/HourGlass.dc1fae8c46bea042dcbfb7569ceb6f32.svg";
export { ForwardRef as ReactComponent };